module.exports = __webpack_public_path__ + "static/image/company/m/image_people@3x.jpg?ba67f02d";